import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgMoreH({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 9a3 3 0 110 6 3 3 0 010-6zM5 9a3 3 0 110 6 3 3 0 010-6zm14 0a3 3 0 110 6 3 3 0 010-6zm-7 2a1 1 0 100 2 1 1 0 000-2zm-7 0a1 1 0 100 2 1 1 0 000-2zm14 0a1 1 0 100 2 1 1 0 000-2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgMoreH
